(function($) {
    plae = window.plae || {};
    plae.callbacks = {
        callbacks: {},
        run: function(type, args) {
            if (this.callbacks[type]) {
                for (var i = 0; i < this.callbacks[type].length; i++) {
                    this.callbacks[type][i].apply(this, args);
                }
            }
        },
        add: function(fun, type) {
            if (!this.callbacks[type]) this.callbacks[type] = [];
            if(fun && type) this.callbacks[type].push(fun);
        }
    };

    // set base media path
    var imagekitenabled = false;
    
    plae.mediapath = (imagekitenabled) ? 'https://m.plae.co/' : '//cdn.shopify.com/s/files/1/0406/7793/3205/files/';

    jQuery(window).on("load", function() {
        if (window.plae && plae.callbacks) plae.callbacks.run("pageload");
    });
})(jQuery);
